import script from "./CatalogCategoryViewV1.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatalogCategoryViewV1.vue?vue&type=script&setup=true&lang=ts"

import "./CatalogCategoryViewV1.vue?vue&type=style&index=0&id=5a5764a6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a5764a6"]])

export default __exports__